import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import AutoComplete from 'components/field/AutoComplete';
import SwitchInput from 'components/field/SwitchInput';
import FormItem from 'components/form/FormItem';
import Typography from 'components/global/Typography';

import useAccessControl from 'hooks/useAccessControl';

import UserForm from 'pages/Users/UserForm';

import { AUTOCOMPLETE } from 'services/consts';

const WMSSettings = ({ mode }) => {
	const viewMode = mode === 'view';
	const isAuthorized = useAccessControl();

	const formMethods = useFormContext();

	const {
		watch,
		formState: { isSubmitting },
		setValue
	} = formMethods;

	const userAutocompleteColumns = useMemo(
		() => [
			{ accessor: 'name', width: 200 },
			{ accessor: 'email', width: 200 }
		],
		[]
	);

	return (
		<>
			<FormItem label="accessibleUsers" isLoading={isSubmitting}>
				<AutoComplete
					name="warehouseUsers"
					disabled={viewMode}
					autoCompleteName={AUTOCOMPLETE.WAREHOUSE_USERS}
					value={watch('warehouseUsers')}
					setValue={(value) => {
						setValue('warehouseUsers', value?.map((item) => item.ID) ?? null, {
							shouldValidate: true,
							shouldDirty: true
						});
					}}
					firstItem={{
						action: () =>
							NiceModal.show(UserForm, {
								setUser: (value) => {
									setValue(`warehouseUsers`, [...(watch('warehouseUsers') ?? []), value], {
										shouldValidate: true,
										shouldDirty: true
									});
								},
								userType: 'warehouseUser'
							}),
						label: <Typography color="var(--blue)">addANewWarehouseUser</Typography>
					}}
					columns={userAutocompleteColumns}
					selectionLabelAccessor={['name']}
					multipleSelection
				/>
			</FormItem>
			{isAuthorized('WMSAdvanceModule') && (
				<>
					<FormItem label="autoPickerAssignment" isLoading={isSubmitting}>
						<SwitchInput formMode viewMode={viewMode} name="autoPickerAssignment" />
					</FormItem>
					{watch('autoPickerAssignment') && (
						<FormItem label="userGroupPicking" isLoading={isSubmitting}>
							<AutoComplete
								valueRemovable={false}
								autoCompleteName={AUTOCOMPLETE.USER_GROUPS}
								filterObject={{
									warehouseID: watch('ID')
								}}
								columns={[{ accessor: 'name', width: 200 }]}
								value={watch('userGroupPicking')}
								disabled={viewMode}
								name={'userGroupPicking'}
								setValue={(value) => {
									setValue('userGroupPicking', value.ID ?? null, {
										shouldDirty: true,
										shouldValidate: true
									});
								}}
								selectionLabelAccessor={['name']}
							/>
						</FormItem>
					)}
				</>
			)}
		</>
	);
};

export default WMSSettings;
